import React from 'react';
import PropTypes from 'prop-types';

const Burger = ({ showMenu, open }) => {
  return (
    <button onClick={showMenu} className={open ? 'burger is-open' : 'burger'}>
      <span className="burger-line line-1"></span>
      <span className="burger-line line-2"></span>
    </button>
  );
};

Burger.propTypes = {
  showMenu: PropTypes.func,
  open: PropTypes.bool,
};

export default Burger;
